<template>
	<BContainer class="py-5">
		<BRow>
			<BCol cols="12">
				<h1 class="m-0 text-center text-primary">404 Not Found</h1>
			</BCol>
		</BRow>
	</BContainer>
</template>